export default __webpack_public_path__ + "static/media/hennesyLogo.6ec4868c.png";